import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";
import {ListPage} from "../../common/ListPage";


import {ShoppingExcelExportIO} from "../../../../io/content/ShoppingExcelExportIO";
import {ShoppingExcelExportValueObject} from "../../../../model/vo/content/ShoppingExcelExportValueObject";
import {
    Button,
    Dialog,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger
} from "@fluentui/react-components";
import {Download, Loader} from "lucide-react";
import {ShoppingExcelExportStatus} from "../../../../constant/ShoppingExcelExportStatus";
import {getCurrentSubDomain} from "../../../HomePage";

export default function List(props: RouteContext) {
    const currentSubDomain = getCurrentSubDomain();

    const onHandleExcelExportFromS3 = (id:bigint) => {
        const url = `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excels/export/${id}`

        fetch(url)
            .then(async value => await value.blob())
            .then(blob => window.URL.createObjectURL(blob))
            .then(url => {
                const a = document.createElement('a')
                a.href = url
                a.download = `${currentSubDomain}-${id}번-비동기요청파일.xlsx`
                a.click()
            })
    }


    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingExcelExportValueObject.description}
                list={ShoppingExcelExportIO.list}
                count={ShoppingExcelExportIO.count}
                delete={ShoppingExcelExportIO.delete}
                detailHref={item => `/admin/shoppings/excelExport/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                initialSortOrders={[
                    {
                        name:'createdAt',
                        order:'DESC'
                    },
                ]}
                itemValue={(item, key) => {
                    if(key == 'status'){
                        switch (item.status){
                            case ShoppingExcelExportStatus.value.Done:
                                return <Button
                                    appearance={'primary'}
                                    icon={<Download />}
                                    onClick={()=>onHandleExcelExportFromS3(item.id)}/>
                            case ShoppingExcelExportStatus.value.Processing:
                                return <Button
                                    appearance={'outline'}
                                    icon={<Loader />}
                                    onClick={()=>onHandleExcelExportFromS3(item.id)}
                                    disabled>{ShoppingExcelExportStatus.description.Processing}</Button>
                            case ShoppingExcelExportStatus.value.Failed:
                                return <Button
                                    appearance={'outline'}
                                    icon={<Loader />}
                                    onClick={()=>onHandleExcelExportFromS3(item.id)}
                                    style={{color:'red'}}
                                    disabled>{ShoppingExcelExportStatus.description.Failed}</Button>
                        }
                        if(item.status === 'DONE')
                            return <Button
                                icon={<Download />}
                                onClick={()=>onHandleExcelExportFromS3(item.id)}/>
                    }
                    else if(key === 's3Key'){
                        return<>
                            <Dialog modalType="non-modal">
                                <DialogTrigger disableButtonEnhancement>
                                    <Button>s3Key</Button>
                                </DialogTrigger>
                                <DialogSurface>
                                    <DialogBody>
                                        <DialogTitle>s3Key 확인</DialogTitle>
                                        <DialogContent>
                                            {item[key]}
                                        </DialogContent>
                                    </DialogBody>
                                </DialogSurface>
                            </Dialog>
                        </>
                    }
                    else return undefined
                }}
            />
        </Column>
    </>
}